"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getTransactionStatus = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var algosdk_1 = require("algosdk");
var errors_1 = require("@ledgerhq/errors");
var errors_2 = require("../../errors");
var tokens_1 = require("./tokens");
var logic_1 = require("./logic");
/*
 * Here are the list of the differents things we check
 * - Check if recipient is the same in case of send
 * - Check if recipient is valid
 * - Check if amounts are set
 * - Check if fees are loaded
 * - Check if is a send Max and set the amount
 * - Check if Token is already optin at the recipient
 * - Check if memo is too long
 */
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, tokenAccount, estimatedFees, amount, totalSpent, algorandResources, algoSpendableBalance, _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                errors = {};
                warnings = {};
                tokenAccount = !t.subAccountId
                    ? null
                    : a.subAccounts && a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; });
                if (!!t.recipient) return [3 /*break*/, 1];
                errors.recipient = new errors_1.RecipientRequired();
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, (0, algosdk_1.isValidAddress)(t.recipient)];
            case 2:
                if (!(_d.sent())) {
                    errors.recipient = new errors_1.InvalidAddress("", {
                        currencyName: a.currency.name
                    });
                }
                else if (t.mode === "send" && a.freshAddress === t.recipient) {
                    errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                }
                _d.label = 3;
            case 3:
                estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
                amount = t.amount;
                totalSpent = estimatedFees;
                (0, invariant_1["default"])(a.algorandResources, "Algorand family expected");
                algorandResources = a.algorandResources;
                algoSpendableBalance = (0, logic_1.computeAlgoMaxSpendable)({
                    accountBalance: a.balance,
                    nbAccountAssets: algorandResources.nbAssets,
                    mode: t.mode
                });
                _a = t.mode;
                switch (_a) {
                    case "send": return [3 /*break*/, 4];
                    case "optIn": return [3 /*break*/, 9];
                    case "claimReward": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 11];
            case 4:
                if (amount.lte(0) && !t.useAllAmount) {
                    errors.amount = new errors_1.AmountRequired();
                }
                if (!t.fees || !t.fees.gt(0)) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                _b = tokenAccount &&
                    tokenAccount.type === "TokenAccount" &&
                    !errors.recipient;
                if (!_b) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, logic_1.recipientHasAsset)(t.recipient, (0, tokens_1.extractTokenId)(tokenAccount.token.id))];
            case 5:
                _b = !(_d.sent());
                _d.label = 6;
            case 6:
                if (_b) {
                    errors.recipient = new errors_2.AlgorandASANotOptInInRecipient();
                }
                amount = t.useAllAmount
                    ? tokenAccount
                        ? tokenAccount.balance
                        : algoSpendableBalance.minus(estimatedFees)
                    : amount;
                if (amount.lt(0)) {
                    amount = new bignumber_js_1.BigNumber(0);
                }
                totalSpent = tokenAccount ? amount : amount.plus(estimatedFees);
                _c = !errors.recipient;
                if (!_c) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, logic_1.isAmountValid)(t.recipient, amount)];
            case 7:
                _c = !(_d.sent());
                _d.label = 8;
            case 8:
                if (_c) {
                    errors.amount = new errors_1.NotEnoughBalanceBecauseDestinationNotCreated("", {
                        minimalAmount: "0.1 ALGO"
                    });
                }
                if (!tokenAccount && amount.gt(0) && estimatedFees.times(10).gt(amount)) {
                    warnings.feeTooHigh = new errors_1.FeeTooHigh();
                }
                if ((amount.lte(0) && t.useAllAmount) || // if use all Amount sets an amount at 0
                    (!errors.recipient && !errors.amount && tokenAccount
                        ? totalSpent.gt(tokenAccount.balance)
                        : totalSpent.gt(algoSpendableBalance)) // if spendable balance lower than total
                ) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                // if spendable balance lower than fees for token
                if (!errors.amount &&
                    tokenAccount &&
                    algoSpendableBalance.lt(estimatedFees)) {
                    errors.amount = new errors_1.NotEnoughBalanceInParentAccount();
                }
                return [3 /*break*/, 11];
            case 9:
                {
                    if (!t.fees || !t.fees.gt(0)) {
                        errors.fees = new errors_1.FeeNotLoaded();
                    }
                    // This error doesn't need to be translate,
                    // it will use to block until the user choose an assetId
                    if (!t.assetId) {
                        errors.assetId = new Error("Asset Id is not set");
                    }
                    if (algoSpendableBalance.lt(estimatedFees)) {
                        errors.amount = new errors_1.NotEnoughBalance();
                    }
                    return [3 /*break*/, 11];
                }
                _d.label = 10;
            case 10:
                {
                    if (algoSpendableBalance.lt(totalSpent)) {
                        errors.amount = new errors_1.NotEnoughBalance();
                    }
                    if (estimatedFees.gt(algorandResources.rewards)) {
                        warnings.claimReward = new errors_2.ClaimRewardsFeesWarning();
                    }
                    return [3 /*break*/, 11];
                }
                _d.label = 11;
            case 11:
                if (t.memo && t.memo.length > logic_1.ALGORAND_MAX_MEMO_SIZE) {
                    throw new Error("Memo is too long");
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
exports.getTransactionStatus = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map